export default "__VITE_ASSET__CbekVBgp__"